'use client';

import { useEffect } from 'react';
import type { Locale } from '@/src/i18n/config';

// Keeps NEXT_LOCALE in step with the page locale. The proxy no longer sets it
// (Set-Cookie blocks CDN edge caching of the HTML), but the cookie must keep
// existing: apiClient/serverClient forward it as x-user-locale, which the API
// uses to localize guest-facing emails (order confirmation, cart-forgotten,
// newsletter welcome, back-in-stock, contact).
export function LocaleCookieSync({ locale }: { readonly locale: Locale }) {
  useEffect(() => {
    const current = document.cookie.match(/(?:^|;\s*)NEXT_LOCALE=([^;]*)/)?.[1];
    if (current !== locale) {
      document.cookie = `NEXT_LOCALE=${locale}; path=/; max-age=31536000; SameSite=Lax`;
    }
  }, [locale]);

  return null;
}
